<template>
  <div class="bar-container bg-color">

    <div class="left">
      <!-- <StartCall :videoCallRoom="videoCallRoom" /> -->
      <BuyExtraMinute :videoCallRoom="videoCallRoom" />
      <Unlimited :videoCallRoom="videoCallRoom" :secondsLeft="remainingTime" />
      <SendToken 
        v-if="videoCallRoom.is_sender"
        @tokensSended="$emit('tokensSended', $event)"
      />
    </div>

    <div class="center">
      <Counter 
        :videoCallRoom="videoCallRoom" 
        @remainingTime="remainingTimeHandler"
        @end="$emit('endCall')" 
      />
    </div>

    <div class="right">
      <ShowLogs ref="showLogs" @show="$emit('showLogs')" @close="$emit('closeLogs')" />
      <Fullscreen 
        @request-fullscreen="$emit('request-fullscreen')"
        @exit-fullscreen="$emit('exit-fullscreen')"
      />
    </div>
  </div>
</template>

<script>
import BuyExtraMinute from "./Button/BuyExtraMinute";
import Fullscreen from "./Button/Fullscreen";
import SendToken from "./Button/SendToken";
// import StartCall from "./Button/StartCall";
import Unlimited from "./Button/Unlimited";
import ShowLogs from "./Button/ShowLogs";
import Counter from "./Counter";

export default {
  components: {
    BuyExtraMinute,
    Fullscreen,
    SendToken,
    // StartCall,
    Unlimited,
    ShowLogs,
    Counter
  },
  data() {
    return {
      remainingTime: 0,
    };
  },
  props: {
    videoCallRoom: {
      required: true,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    remainingTimeHandler(e) {
      this.remainingTime = e;
    },
    closeLogListHandler() {
      this.$refs.showLogs.closeHandler();
    },
  },
};
</script>

<style scoped lang="scss">
@import "./jisti.scss";

.bar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 425px) {
    justify-content: center;

    /deep/ .left > .ccontainer:not(.ccontainer-icon) {
      margin-right: 0.5em;
    }

    /deep/ .right > .ccontainer:not(.ccontainer-icon) {
      margin-left: 0.5em;
    }

    /deep/ .right > .ccontainer.ccontainer-icon {
      margin-right: -0.5em;
      margin-left: -0.5em;
    }

    /deep/ .left > .ccontainer.ccontainer-icon {
      margin-right: -0.5em;
      margin-left: -0.5em;
    }
  }

  /deep/ .left > .ccontainer:not(.ccontainer-icon) {
    margin-left: 0.5em;
  }

  /deep/ .right > .ccontainer:not(.ccontainer-icon) {
    margin-right: 0.5em;
  }

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
